(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-artists"] && !Shopify.designMode) return;
  try {
    
class MPArtistCatalog extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.config = JSON.parse(this.querySelector('[data-mp-config]').textContent);
    this.grid = this.querySelector('[data-mp-grid]');
    this.status = this.querySelector('[data-mp-status]');
    this.pagination = this.querySelector('[data-mp-pagination]');
    this.pageSize = 40;
    this.page = 1;
    this.query = '';
    this.items = [];
    this.searchInput = document.getElementById('MpArtistSearch');
    if (this.searchInput) {
      this.searchInput.addEventListener('input', () => {
        this.query = this.searchInput.value.toLowerCase().trim();
        this.page = 1;
        this.render();
      });
    }
    this.load();
  }

  async load() {
    try {
      const all = [];
      const visited = new Set();
      let next = new URL(this.config.url, location.origin);
      next.searchParams.set('view', 'mp-catalog');
      while (next) {
        const key = next.toString();
        if (visited.has(key)) break;
        visited.add(key);
        const response = await fetch(next, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('catalog unavailable');
        const data = await response.json();
        if (!Array.isArray(data.collections)) throw new Error('invalid catalog');
        all.push(...data.collections);
        if (data.next) {
          next = new URL(data.next, location.origin);
          next.searchParams.set('view', 'mp-catalog');
        } else {
          next = null;
        }
      }
      const excluded = new Set(this.config.excluded || []);
      this.items = all.filter(c => c.count > 0 && !excluded.has(c.handle));
      this.items.sort((a, b) => b.count - a.count);
      this.render();
    } catch (error) {
      this.status.textContent = 'Impossible de charger les artistes pour le moment.';
    }
  }

  escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  render() {
    let items = this.items;
    if (this.query) {
      items = items.filter(c => c.title.toLowerCase().indexOf(this.query) > -1);
    }
    const pages = Math.max(1, Math.ceil(items.length / this.pageSize));
    this.page = Math.min(this.page, pages);
    const start = (this.page - 1) * this.pageSize;
    const pageItems = items.slice(start, start + this.pageSize);
    this.grid.innerHTML = pageItems.map((c, index) => {
      const globalIndex = start + index;
      const featured = globalIndex < 3;
      const img = c.image ? '<img src="' + c.image + '" loading="lazy" alt="' + this.escapeHtml(c.title) + '">' : '';
      const count = c.count || 0;
      return '<a class="mp-artist-directory__item' + (featured ? ' mp-artist-directory__item--featured' : '') + '" data-artist="' + this.escapeHtml(c.title.toLowerCase()) + '" href="' + c.url + '"><div class="mp-artist-directory__media">' + img + '</div><h2>' + this.escapeHtml(c.title) + '</h2><p class="mp-artist-directory__count">' + count + (count === 1 ? ' œuvre' : ' œuvres') + '</p></a>';
    }).join('');
    this.status.textContent = items.length ? '' : (this.config.empty || '');
    this.pagination.innerHTML = '';
    this.pagination.hidden = pages <= 1;
    if (pages > 1) {
      if (this.page > 1) {
        const prev = document.createElement('button');
        prev.type = 'button';
        prev.className = 'mp-link';
        prev.textContent = 'Précédent';
        prev.addEventListener('click', () => { this.page -= 1; this.render(); this.grid.scrollIntoView({ block: 'start' }); });
        this.pagination.append(prev);
      }
      const span = document.createElement('span');
      span.textContent = this.page + ' / ' + pages;
      this.pagination.append(span);
      if (this.page < pages) {
        const nextBtn = document.createElement('button');
        nextBtn.type = 'button';
        nextBtn.className = 'mp-link';
        nextBtn.textContent = 'Suivant';
        nextBtn.addEventListener('click', () => { this.page += 1; this.render(); this.grid.scrollIntoView({ block: 'start' }); });
        this.pagination.append(nextBtn);
      }
    }
  }
}
if (!customElements.get('mp-artist-catalog')) customElements.define('mp-artist-catalog', MPArtistCatalog);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mp-collection"] && !Shopify.designMode) return;
  try {
    
class MPArtworkCatalog extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.ready = true;
    this.config = JSON.parse(this.querySelector('[data-mp-config]').textContent);
    this.form = this.querySelector('form');
    this.grid = this.querySelector('[data-mp-grid]');
    this.pagination = this.querySelector('[data-mp-pagination]');
    this.status = this.querySelector('[data-mp-status]');
    this.error = this.querySelector('[data-mp-error]');
    this.facets = [...this.querySelectorAll('[data-mp-facet]')];
    this.cache = new Map();
    this.requestNumber = 0;
    this.readURL();
    this.createArtists();
    this.querySelector('[data-mp-controls]').hidden = false;
    this.updateControls();
    this.form.addEventListener('change', event => {
      if (event.target.name === 'mp_size' || event.target.name === 'sort_by') {
        this.state.size = this.form.elements.mp_size.value;
        this.state.sort = this.form.elements.sort_by.value;
        this.state.page = 1;
        this.apply(true);
      }
    });
    this.querySelector('[data-mp-artists]').addEventListener('click', event => {
      const button = event.target.closest('[data-mp-artist]');
      if (!button) return;
      this.state.artist = button.dataset.mpArtist;
      this.state.page = 1;
      this.apply(true);
    });
    this.facets.forEach(group => group.addEventListener('click', event => {
      const button = event.target.closest('[data-mp-value]');
      if (!button) return;
      this.state[group.dataset.mpFacet] = button.dataset.mpValue;
      this.state.page = 1;
      this.apply(true);
    }));
    this.querySelector('[data-mp-reset]').addEventListener('click', () => {
      this.state.size = '';
      this.state.artist = '';
      this.state.technique = '';
      this.state.support = '';
      this.state.page = 1;
      this.apply(true);
    });
    this.querySelector('[data-mp-retry]').addEventListener('click', () => this.apply(false));
    this.pagination.addEventListener('click', event => {
      const link = event.target.closest('[data-mp-page]');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      this.state.page = Number(link.dataset.mpPage);
      this.apply(true, true);
    });
    this.form.addEventListener('submit', event => {
      event.preventDefault();
      const url = new URL(location.href);
      for (const key of [...url.searchParams.keys()]) {
        if (key.startsWith('filter.') || key === 'page' || key === 'mp_page') url.searchParams.delete(key);
      }
      for (const [key, value] of new FormData(this.form)) {
        if (value) url.searchParams.append(key, value);
      }
      const values = { mp_size: this.state.size, mp_artist: this.state.artist, mp_technique: this.state.technique, mp_support: this.state.support, sort_by: this.state.sort };
      for (const [key, value] of Object.entries(values)) {
        if (value) url.searchParams.set(key, value);
        else url.searchParams.delete(key);
      }
      location.assign(url.toString());
    });
    this.onPopState = () => {
      this.readURL();
      this.apply(false);
    };
    window.addEventListener('popstate', this.onPopState);
    this.apply(false);
  }

  disconnectedCallback() {
    window.removeEventListener('popstate', this.onPopState);
  }

  readURL() {
    const params = new URL(location.href).searchParams;
    const size = params.get('mp_size') || '';
    this.state = {
      size: ['small', 'medium', 'large'].includes(size) ? size : '',
      artist: params.get('mp_artist') || '',
      technique: params.get('mp_technique') || '',
      support: params.get('mp_support') || '',
      sort: params.get('sort_by') || this.config.defaultSort,
      page: Math.max(1, parseInt(params.get('mp_page') || params.get('page') || '1', 10) || 1)
    };
  }

  createArtists() {
    const order = this.config.ranked.split('|').map(name => name.trim()).filter(Boolean);
    const ranking = new Map(order.map((name, index) => [name, index]));
    const artists = [...this.config.artists].sort((a, b) =>
      (ranking.get(a) ?? order.length) - (ranking.get(b) ?? order.length)
    );
    const primary = this.querySelector('[data-mp-artist-primary]');
    const more = this.querySelector('[data-mp-artist-more]');
    const createButton = (name, text) => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'mp-catalog-chip';
      button.dataset.mpArtist = name;
      button.textContent = text;
      return button;
    };
    primary.append(createButton('', this.config.all));
    artists.forEach((artist, index) => (index < 8 ? primary : more).append(createButton(artist, artist)));
    this.querySelector('[data-mp-more]').hidden = artists.length <= 8;
  }

  /* Technique / support chips, built from the artworks themselves. Only values that still
     have results with the other active filters are shown. */
  renderFacets(products, match) {
    this.facets.forEach(group => {
      const facet = group.dataset.mpFacet;
      const current = this.state[facet];
      const values = new Map();
      products.forEach(product => {
        const value = product[facet];
        if (!value) return;
        const entry = values.get(value) || { label: product[facet + 'Label'] || value, total: 0, count: 0 };
        entry.total += 1;
        if (match(product, facet)) entry.count += 1;
        values.set(value, entry);
      });
      const createButton = (value, text) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'mp-catalog-chip';
        button.dataset.mpValue = value;
        button.textContent = text;
        button.setAttribute('aria-pressed', String(value === current));
        return button;
      };
      const shown = [...values.entries()]
        .filter(([value, entry]) => entry.count > 0 || value === current)
        .sort((a, b) => b[1].total - a[1].total);
      group.querySelector('[data-mp-facet-chips]').replaceChildren(
        createButton('', group.dataset.mpAll || this.config.all),
        ...shown.map(([value, entry]) => createButton(value, entry.label))
      );
      group.hidden = values.size < 2;
    });
  }

  updateControls() {
    const sizeInput = [...this.querySelectorAll('[name="mp_size"]')].find(input => input.value === this.state.size);
    if (sizeInput) sizeInput.checked = true;
    this.form.elements.sort_by.value = this.state.sort;
    this.form.elements.mp_artist.value = this.state.artist;
    this.querySelectorAll('[data-mp-artist]').forEach(button => {
      const selected = button.dataset.mpArtist === this.state.artist;
      button.setAttribute('aria-pressed', String(selected));
      if (selected && button.closest('[data-mp-artist-more]')) this.querySelector('[data-mp-more]').open = true;
    });
    this.facets.forEach(group => {
      const current = this.state[group.dataset.mpFacet];
      group.querySelectorAll('[data-mp-value]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.mpValue === current)));
    });
    this.querySelector('[data-mp-reset]').hidden = !this.state.size && !this.state.artist && !this.state.technique && !this.state.support;
  }

  urlFor(page = this.state.page) {
    const url = new URL(location.href);
    url.searchParams.delete('page');
    for (const [key, value] of [['mp_size', this.state.size], ['mp_artist', this.state.artist], ['mp_technique', this.state.technique], ['mp_support', this.state.support], ['sort_by', this.state.sort], ['mp_page', page > 1 ? String(page) : '']]) {
      if (value) url.searchParams.set(key, value);
      else url.searchParams.delete(key);
    }
    return url;
  }

  async loadProducts(sort) {
    const url = new URL(this.config.url, location.origin);
    for (const [key, value] of new URL(location.href).searchParams) {
      if (key.startsWith('filter.') || key === 'preview_theme_id') url.searchParams.append(key, value);
    }
    url.searchParams.set('view', 'mp-catalog');
    url.searchParams.set('sort_by', sort);
    const key = url.toString();
    if (this.cache.has(key)) return this.cache.get(key);
    const task = (async () => {
      const products = [];
      const visited = new Set();
      let next = url;
      while (next) {
        if (visited.has(next.toString())) throw new Error('Repeated catalog page');
        visited.add(next.toString());
        const response = await fetch(next, { credentials: 'same-origin', signal: AbortSignal.timeout(25000) });
        if (!response.ok) throw new Error('Catalog unavailable');
        const data = await response.json();
        if (!Array.isArray(data.products)) throw new Error('Invalid catalog');
        products.push(...data.products);
        if (data.next) {
          const target = new URL(data.next, location.origin);
          if (target.origin !== location.origin) throw new Error('Invalid catalog origin');
          target.searchParams.set('view', 'mp-catalog');
          if (url.searchParams.has('preview_theme_id')) target.searchParams.set('preview_theme_id', url.searchParams.get('preview_theme_id'));
          next = target;
        } else {
          next = null;
          if (products.length !== data.total) throw new Error('Incomplete catalog');
        }
      }
      return products;
    })();
    this.cache.set(key, task);
    try { return await task; }
    catch (error) { this.cache.delete(key); throw error; }
  }

  async apply(push, focusGrid = false) {
    const request = ++this.requestNumber;
    this.updateControls();
    this.error.hidden = true;
    this.grid.hidden = false;
    this.pagination.hidden = true;
    this.setAttribute('aria-busy', 'true');
    this.status.textContent = this.config.loading;
    try {
      const products = await this.loadProducts(this.state.sort);
      if (request !== this.requestNumber) return;
      const match = (product, skip) =>
        (!this.state.size || product.size === this.state.size) &&
        (!this.state.artist || product.artist === this.state.artist) &&
        (skip === 'technique' || !this.state.technique || product.technique === this.state.technique) &&
        (skip === 'support' || !this.state.support || product.support === this.state.support);
      this.renderFacets(products, match);
      const matches = products.filter(product => match(product));
      matches.sort((a, b) => (a.state === 'sold' ? 1 : 0) - (b.state === 'sold' ? 1 : 0));
      const pages = Math.max(1, Math.ceil(matches.length / 24));
      this.state.page = Math.min(this.state.page, pages);
      const start = (this.state.page - 1) * 24;
      this.grid.innerHTML = matches.slice(start, start + 24).map(product => product.html).join('');
      this.status.textContent = matches.length ? this.config.results.replace('[count]', String(matches.length)) : this.config.empty;
      this.pagination.replaceChildren();
      const pageLink = (page, label) => {
        const link = document.createElement('a');
        link.className = 'mp-link';
        link.dataset.mpPage = String(page);
        link.href = this.urlFor(page).toString();
        link.textContent = label;
        return link;
      };
      if (this.state.page > 1) this.pagination.append(pageLink(this.state.page - 1, this.config.previous));
      if (pages > 1) {
        const label = document.createElement('span');
        label.textContent = this.state.page + ' / ' + pages;
        label.setAttribute('aria-current', 'page');
        this.pagination.append(label);
      }
      if (this.state.page < pages) this.pagination.append(pageLink(this.state.page + 1, this.config.next));
      this.grid.hidden = false;
      this.pagination.hidden = pages <= 1;
      if (push) history.pushState({}, '', this.urlFor());
      if (focusGrid) {
        this.grid.focus({ preventScroll: true });
        this.status.scrollIntoView({ block: 'start', behavior: 'auto' });
      }
    } catch (error) {
      if (request !== this.requestNumber) return;
      this.status.textContent = '';
      this.error.hidden = false;
      this.grid.hidden = false;
      this.pagination.hidden = !this.pagination.querySelector('a');
    } finally {
      if (request === this.requestNumber) this.setAttribute('aria-busy', 'false');
    }
  }
}
if (!customElements.get('mp-artwork-catalog')) customElements.define('mp-artwork-catalog', MPArtworkCatalog);


  } catch(e) { console.error(e); }
})();
})();
